import {
  StudentQuestionBehaviorStates,
  StudentQuestionBehaviorStateType
} from '../../../api/student-question';
import { ArrowPathIcon, InformationCircleIcon, XCircleIcon } from '@heroicons/react/24/outline';
import { useUpdateStudentQuestionBehaviorStateMutation } from '../../../hooks/react-query/use-student-question';
import { useCallback } from 'react';
import Button from '../../shared/buttons/button';
import classNames from 'classnames';

export type StudentQuestionBehaviorStatePropsType = {
  studentQuestionId: number;
  behaviorState: StudentQuestionBehaviorStateType;
  openModal: () => void;
};

function BehaviorState({
  studentQuestionId,
  behaviorState,
  openModal
}: StudentQuestionBehaviorStatePropsType) {
  const { mutateAsync: updateStudentQuestionBehaviorState, isLoading } =
    useUpdateStudentQuestionBehaviorStateMutation();

  const handleClick = useCallback(
    async (nextState: StudentQuestionBehaviorStateType) => {
      if (isLoading) return;

      await updateStudentQuestionBehaviorState({
        studentQuestionId,
        behaviorState:
          nextState === behaviorState ? StudentQuestionBehaviorStates.NORMAL : nextState
      });
    },
    [behaviorState, isLoading, studentQuestionId, updateStudentQuestionBehaviorState]
  );

  return (
    <div className='flex items-center justify-between gap-2'>
      <InformationCircleIcon width={21} height={21} onClick={openModal} className='text-gray-500' />
      <Button
        outline
        size='xs'
        color={behaviorState === StudentQuestionBehaviorStates.WILL_RETURN ? 'blue' : 'gray'}
        onClick={() => handleClick(StudentQuestionBehaviorStates.WILL_RETURN)}
        className={classNames({
          'border-2': behaviorState === StudentQuestionBehaviorStates.WILL_RETURN
        })}
      >
        <ArrowPathIcon
          width={20}
          height={20}
          className={
            behaviorState === StudentQuestionBehaviorStates.WILL_RETURN
              ? 'stroke-[3] text-blue-500'
              : 'text-gray-500'
          }
        />
      </Button>
      <Button
        outline
        size='xs'
        color={behaviorState === StudentQuestionBehaviorStates.ABANDONED ? 'red' : 'gray'}
        onClick={() => handleClick(StudentQuestionBehaviorStates.ABANDONED)}
        className={classNames({
          'border-2': behaviorState === StudentQuestionBehaviorStates.ABANDONED
        })}
      >
        <XCircleIcon
          width={20}
          height={20}
          className={
            behaviorState === StudentQuestionBehaviorStates.ABANDONED
              ? 'stroke-[3] text-red-500'
              : 'text-gray-500'
          }
        />
      </Button>
    </div>
  );
}

export default BehaviorState;
